import BaseModal from 'components/Modals/BaseModal';

const ResponderBaseModal = ({
  show = false,
  onHide = () => {},
  title = '',
  size = 'lg',
  centered = true,
  closeButton = true,
  footer = null,
  className = '',
  contentStyle,
  children,
  ...rest
}) => {
  const classNames = ['responder-base-modal', className].filter(Boolean).join(' ');

  return (
    <BaseModal
      show={show}
      handleShow={onHide}
      title={title}
      size={size}
      closeButton={closeButton}
      footer={footer}
      centered={centered}
      className={classNames}
      backdropClassName="responder-alert-backdrop"
      contentStyle={contentStyle}
      {...rest}
    >
      {children}
    </BaseModal>
  );
};

export default ResponderBaseModal;
